import Vue from "vue";
import VueRouter from "vue-router";
import StepOne from "../components/StepOne.vue";
import StepTwo from "../components/StepTwo.vue";
import StepThree from "../components/StepThree";
import StepFour from "../components/StepFour";
import StepFive from "../components/StepFive";
import FormPage from "../views/FormPage.vue";
import TicketPart from '@/components/fileElement/TicketPart'
import LoginComp from "../components/Account/LoginComp.vue";
import PolicyComp from "../components/Account/PolicyComp.vue";
import ConditionComp from "../components/Account/ConditionComp.vue";
import RegisterComp from "../components/Account/RegisterComp.vue";
import ForgetPasswordComp from "../components/Account/ForgetPasswordComp.vue";
import ChangePasswordComp from "../components/Account/ChangePasswordComp.vue";
import ChangePasswordLandingPage from "../views/ChangePasswordLandingPage.vue"
import PasswordExpired from '@/components/Account/PasswordExpired';
import RegistrationFormListPage from "@/views/admin/registrationForm/RegistrationFormListPage";
import RegistrationFormAddPage from "@/views/admin/registrationForm/RegistrationFormAddPage";
import RegistrationFormEditPage from "@/views/admin/registrationForm/RegistrationFormEditPage";
import RegistrationFormViewPage from "@/views/admin/registrationForm/RegistrationFormViewPage";
import RegistrationCalendarListPage from "@/views/admin/registrationCalendar/RegistrationCalendarListPage";
import RegistrationCalendarPage from "@/views/admin/registrationCalendar/RegistrationCalendarPage";
import RegistrationPlanPage from "@/views/admin/registrationPlan/RegistrationPlanPage";
import CandidatesPage from "@/views/admin/CandidatesPage.vue";
import QualifiedPage from "@/views/admin/QualifiedPage.vue";
import StudentSummit from '@/components/formPartial/StudentSummit.vue';
import ErrorComp from '@/components/Account/ErrorComp.vue';
import ApplicationFormLandingPage from "@/views/ApplicationFormLandingPage"
import TicketForm from "@/components/fileElement/TicketForm.vue"
import Redirect from "@/views/Redirect";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",

  routes: [
    {
      path: "/",
      name: "DefaultRegistrationFormListPage",
      component: RegistrationFormListPage,
    },
    {
      path: "/login",
      name: "LoginPage",
      component: LoginComp,
    },
    {
      path: "/registration/qualified",
      name: "QualifiedPage",
      component: QualifiedPage,
    },
    {
      path: "/registration/calendar/:id/grade-plans/:plan_id/applicant/:applicantId",
      name: "CandidatesPage",
      component: CandidatesPage,
    },
    {
      path: "/registration/form",
      name: "RegistrationForm",
      component: RegistrationFormListPage,
    },
    {
      path: "/registration/form/:id/view",
      name: "RegistrationFormView",
      component: RegistrationFormViewPage,
    },
    {
      path: "/registration/form/add",
      name: "RegistrationFormAdd",
      component: RegistrationFormAddPage,
    },
    {
      path: "/registration/form/:id/edit",
      name: "RegistrationFormEdit",
      component: RegistrationFormEditPage,
    },
    {
      path: "/registration/calendar",
      name: "RegistrationCalendarList",
      component: RegistrationCalendarListPage,
    },
    {
      path: "/registration/calendar/:id",
      name: "RegistrationCalendar",
      component: RegistrationCalendarPage,
    },
    {
      path: "/registration/calendar/:id/grade-plans/:plan_id",
      name: "RegistrationPlan",
      component: RegistrationPlanPage,
    },
    {
      path: "/form/step1",
      name: "StepOne",
      component: StepOne,
    },
    {
      path: "/form/step2",
      name: "StepTwo",
      component: StepTwo,
    },
    {
      path: "/form/step3",
      name: "stepThree",
      component: StepThree,
    },
    {
      path: "/form/step4",
      name: "stepFour",
      component: StepFour,
    },
    {
      path: "/form/step5",
      name: "stepFive",
      component: StepFive,
    },
    {
      path: "/form/:stepId",
      name: "FormPage",
      component: FormPage,
    },
    {
      path: "/application-form/:link",
      name: "ApplicationFormLanding",
      component: ApplicationFormLandingPage,
    },
    {
      path: "/register",
      name: "RegisterComp",
      component: RegisterComp,
    },
    {
      path: "/account/forget-password",
      name: "ForgetPasswordComp",
      component: ForgetPasswordComp,
    },
    {
      path: "/account/change-password/:token",
      name: "ChangePasswordComp",
      component: ChangePasswordComp,
    },
    {
      path: "/account/forget-password/:token",
      name: "ChangePasswordCompLanding",
      component: ChangePasswordLandingPage,
    },
    {
      path: "/account/policy",
      name: "PolicyComp",
      component: PolicyComp,
    },
    {
      path: "/account/condition",
      name: "ConditionComp",
      component: ConditionComp,
    },
    {
      path: "/form/5/success",
      name: "StudentSummit",
      component: StudentSummit,
    },
    {
      path: "/error",
      name: "ErrorComp",
      component: ErrorComp,
    },
    {
      path: "/ticket",
      name: "TicketForm",
      component: TicketForm,
    },
    {
      path: "/ticket/part",
      name: "TicketPart",
      component: TicketPart,
    },
    {
      path: "/password_expired",
      name: "PasswordExpired",
      component: PasswordExpired,
    },
    {
      path: "/redirect",
      name: "RedirectAndGetToken",
      component: Redirect
    }
  ],
});

export default router;
